
import React from "react";
import { ChartContainer, ChartTooltip, ChartTooltipContent } from "@/components/ui/chart";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";

export const BubbleCareStats = () => {
  // Mock data - in a real app, this would come from an API
  const data = [
    { name: "Healthcare", value: 520, color: "#8B5CF6" },
    { name: "Transportation", value: 380, color: "#10B981" },
    { name: "Companionship", value: 290, color: "#F59E0B" },
    { name: "Meals", value: 180, color: "#EF4444" },
    { name: "Other", value: 102, color: "#6B7280" }
  ];

  return (
    <div className="h-[200px]">
      <ChartContainer
        config={{
          healthcare: { color: "#8B5CF6" },
          transportation: { color: "#10B981" },
          companionship: { color: "#F59E0B" },
          meals: { color: "#EF4444" },
          other: { color: "#6B7280" }
        }}
      >
        <PieChart margin={{ top: 5, right: 5, bottom: 5, left: 5 }}>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            innerRadius={40}
            outerRadius={80}
            paddingAngle={2}
            dataKey="value"
            label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
            labelLine={false}
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Pie>
          <ChartTooltip content={<ChartTooltipContent />} />
        </PieChart>
      </ChartContainer>
    </div>
  );
};
